module.exports = __webpack_public_path__ + "img/1_028.68f89669.jpg";